import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { GeneralService } from '../general.service';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { WalletComponent } from '../wallet/wallet.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: [
    '../dasboard/dasboard.component.css',
    '../create-policy/create-policy.component.css',
    './profile.component.css',
  ],
})
export class ProfileComponent implements OnInit {
  paystack: string = '';
  constructor(
    private fb: FormBuilder,
    private authServ: AuthService,
    private tstr: ToastrService,
    private service: GeneralService,
    private r: Router,
    public dialog: MatDialog
  ) {}
  jsk = 11;
  form = this.fb.group({
    cac_number: ['', Validators.pattern(/[BN|RC|IT|LP|LLP]\d{5,}$/)],
    phone: [
      '',
      Validators.compose([
        Validators.required,
        Validators.maxLength(11),
        Validators.minLength(11),
        Validators.pattern('^[0-9]*$'),
      ]),
    ],
    address: ['', Validators.required],
    name: ['', Validators.required],
    status: [''],
  });

  file: any;
  upl = false;
  pendingd = true;
  queried = false;
  user: { [key: string]: string } = {};
  walletBalance: { [key: string]: any } = {};
  amount: { [key: string]: any } = {};
  isCacDetails = false;
  ngOnInit(): void {
    // console.log(this.upl);
    this.walletBalance = JSON.parse(localStorage.getItem('wallet')!);
    this.authServ.chkcr();
    this.user = JSON.parse(localStorage.getItem('user')!);
    if (this.user['cac_number']) {
      this.isCacDetails = true;
    }
    // if(this.authServ.cacInfo){
    //   this.form.controls.cac_number.setValue(this.authServ.cacInfo['cac']['rcNumber'])
    //   this.form.controls.cac_number.disable()
    //   this.form.controls.address.setValue(this.authServ.cacInfo['cac']['headOfficeAddress'])
    //   this.form.controls.address.disable()
    //   this.form.controls.name.setValue(this.authServ.cacInfo['cac']['companyName'])
    //   this.form.controls.name.disable()
    // }

    if (this.user['status'] == 'queried') {
      this.queried = true;
      this.form.controls.address.setValue(this.user['address']);
      this.form.controls.phone.setValue(this.user['phone']);
      this.form.controls.cac_number.setValue(this.user['cac_number']);
      this.form.controls.name.setValue(this.user['name']);
    }
    // if (this.user['status'] == 'approved' || this.user['status'] == 'pending' && this.upl) {
    //   this.pendingd = false;
    //   // console.log(this.pendingd);
    // }
  }
  getCacDetails() {
    this.authServ
      .basicCac({ idNumber: this.form.value['cac_number'] })
      .subscribe((r) => {
        this.authServ.loader = false;
        this.tstr.success('Sucessfully verify CAC Number');
        this.isCacDetails = true;
        this.form.controls.cac_number.setValue(r['cac']['rcNumber']);
        this.form.controls.cac_number.disable();
        this.form.controls.address.setValue(r['cac']['headOfficeAddress']);
        if (r['cac']['headOfficeAddress']) {
          this.form.controls.address.disable();
        }
        this.form.controls.name.setValue(r['cac']['companyName']);
        this.form.controls.name.disable();
      });
  }

  selectIm(event: any) {
    this.file = event.target.files[0];
  }
  submit() {
    let formData = new FormData();
    formData.append('name', this.form.controls.name.value!);
    formData.append('address', this.form.controls.address.value!);
    formData.append('phone', this.form.controls.phone.value!);
    formData.append(
      'cac_number',
      this.form.controls.cac_number.value!.toString()
    );
    formData.append('file', this.file);
    this.authServ.updt(formData).subscribe((r: any) => {
      console.log(r); 
      this.authServ.loader = false;
      localStorage.setItem('user', JSON.stringify(r.data));
      // localStorage.setItem('cert', 'uploaded');
      this.upl = true;
      this.tstr.success('Successfully Uploaded your CAC details');
      location.reload();
    });
    this.r.navigateByUrl('/welcome');
  }
  submitQuery() {
    this.form.value['status'] = 'pending';
    if (this.file) {
      let formData = new FormData();
      formData.append('file', this.file);
      this.service.submitQuery(formData, this.form.value).subscribe((r) => {
        this.user['status'] = 'pending';
        localStorage.setItem('user', JSON.stringify(this.user));
        this.service.loader = false;
        this.tstr.success('Successfully Uploaded your CAC details');
        location.reload();
      });
    } else {
      this.service.submitQuery(false, this.form.value).subscribe((r) => {
        this.user['status'] = 'pending';
        localStorage.setItem('user', JSON.stringify(this.user));
        this.service.loader = false;
        this.tstr.success('Successfully Uploaded your CAC details');
        location.reload();
      });
    }
  }

  fundWallet() {
    const dialogRef = this.dialog.open(WalletComponent, {
      // height: '90vh',
      // width: '90vw',
    });

    dialogRef.afterClosed().subscribe((result) => {
      
    });
  }
}
